import { defineStore } from "pinia";

export const useUiStore = defineStore({
  id: "ui-store",
  state: () => {
    return {
      colorMode: null as "light" | "dark" | null,
      xhrRequests: {} as { [key: string]: boolean },
    };
  },
  actions: {
    setColorMode(colorMode: "light" | "dark") {
      this.colorMode = colorMode;
      useNuxtApp().$colorMode.preference = colorMode;
    },
    getters: {
      colorMode(): "light" | "dark" {
        return this.colorMode as "light" | "dark";
      },
    },
    addRequest(requestId: string) {
      this.xhrRequests[requestId] = true;
    },
    requestFinished(requestId: string) {
      if (this.xhrRequests[requestId]) {
        delete this.xhrRequests[requestId];
      }
    },
  },
  getters: {
    hasRequests(): boolean {
      return Object.keys(this.xhrRequests).length > 0;
    },
    currentColorMode(): "light" | "dark" {
      const colorMode = useNuxtApp().$colorMode.preference as "light" | "dark";
      if (this.colorMode === null) {
        this.colorMode = colorMode;
      }
      return this.colorMode as "light" | "dark";
    },
  },
});

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useUiStore, import.meta.hot));
}
